import styled from '@emotion/styled';

export const SystemSettingsFormWrapper = styled('div', { label: 'SystemSettingsFormWrapper' })`
    display: flex;
    flex-flow: column nowrap;
    flex: 1 1 0%;
`;
